import Head from "next/head";
import FallbackHeader from "@/src/components/elements/Headers/fallback";
import Cookies from "universal-cookie";
import { useDevice, useGetLocalStorage } from "@/src/hooks/index";
import Home from "@/src/feature/main/user/home";
import HomeTablet from "@/src/feature/main/user/landing/containers/intro";
import { HomeLayout } from "@/src/components/layouts/index";
import { bottomNavMantri } from "@/src/datas/menu";
import PageMantri from "@/src/feature/main/user/home/mantri/index";
import Header from "@/src/components/elements/Header/index";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";

export default function IndexPage() {
  const device: "mobile" | "desktop" | undefined = useDevice();
  const cookie = new Cookies();
  const session = cookie?.get("user") !== undefined;
  const data: string | null = useGetLocalStorage("data");
  const userData = JSON?.parse(String(data));
  const filteredMobile = userData?.access?.filter((item: any) =>
    item?.device?.some((dv: any) => dv?.device === "mobile"),
  );

  console.log("device", device);
  console.log("MF_BRIBRAIN_DESKTOP", process.env.MF_BRIBRAIN_DESKTOP);
  const [detectedDevice, setDetectedDevice] = useState("");
  const handleLogin = () => {
    window?.location?.assign("/login");
  };

  const router = useRouter();
  useEffect(() => {
    device && setDetectedDevice(device);
  }, [device, detectedDevice]);

  if (device === "mobile" && !session) {
    // if (screen.width < 768) {
    return (
      <>
        <Home id={"Home"} />
      </>
    );
    // } else if (screen.width >= 768) {
    //   return (
    //     <>
    //       <HomeTablet id={"Home-Tablet"} />
    //     </>
    //   );
    // }
  } else if (device === "mobile" && session && userData?.role === "MANTRI") {
    return (
      <>
        <Head>
          <title>
            BRIBrain - Tingkatkan produktivitas tenaga pemasar dengan BRIBRAIN
          </title>
        </Head>
        <HomeLayout tab="/" menus={bottomNavMantri}>
          <Header logo={true} />
          <PageMantri />
        </HomeLayout>
      </>
    );
  } else if (device === "mobile" && session) {
    if (filteredMobile?.length === 1) {
      if (filteredMobile?.[0]?.role?.toLowerCase() === "rm") {
        window?.location?.assign("/link5/rekomendasi");
      } else {
        const routeDevice = filteredMobile?.[0]?.device?.find(
          (dv: any) => dv.device === "mobile",
        );
        window?.location?.assign(`${routeDevice.main_url}${routeDevice.uri}`);
      }
    } else {
      router.push("/menu");
    }
  } else if (device === "desktop") {
    window?.location?.assign(`${process.env.MF_BRIBRAIN_DESKTOP}`);
  }
  return <FallbackHeader />;
}
